import React, {useMemo, useState} from "react";
import {Box, Stack, Tabs, Typography} from "@mui/material";
import {EditOutlined, HeartBrokenOutlined, ReplyOutlined} from "@mui/icons-material";
import {Page} from "../app/Page";
import {FormsManagedTab} from "../forms-list/FormsManagedCardList";
import {useUser} from "../user-auth/UserProvider";
import {UserRequiredRedirect} from "../user-auth/UserRequiredRedirect";
import {t} from "i18next";
import Tab from "@mui/material/Tab";
import {FormsCardList} from "../forms-list/FormsCardList";
import {PreHospitalWorkflowsTab} from "../pre-hospital-workflow/PreHospitalWorkflowsList";

const pillTabSx = {
    minHeight: 0,
    borderRadius: 999,
    textTransform: 'none',
    px: 2.5,
    py: 1,
    color: 'text.secondary',
    '&.Mui-selected': {
        bgcolor: 'background.paper',
        color: 'primary.main',
        boxShadow: 0,
    },
};

export function HomePageMiddleware() {
    const user = useUser();
    if (!user.logged) {
        return <UserRequiredRedirect />;
    }
    return <HomePage />;
}

function HomePage() {
    const user = useUser();
    
    const availableTabs = useMemo(() => {
        const tabs = [];
        if (user.data.canManagePreHospitalWorkflows) {
            tabs.push('preHospitalWorkflows');
        }
        tabs.push('userForms');
        if (user.data.canManageForms) {
            tabs.push('dashboardForms');
        }
        return tabs;
    }, [user.data.canManageForms, user.data.canManagePreHospitalWorkflows]);

    const [currentTab, setCurrentTab] = useState(availableTabs.length ? availableTabs[0] : null);

    return (
        <Page>
            <Box sx={{display: 'flex', justifyContent: 'center', mb: 4}}>
                <Tabs
                    value={currentTab}
                    TabIndicatorProps={{style: {display: 'none'}}}
                    sx={{
                        minHeight: 0,
                        bgcolor: 'action.hover',
                        borderRadius: 999,
                        p: 0.5,
                        '& .MuiTabs-flexContainer': {gap: 0.5},
                    }}
                >
                    {availableTabs.includes('preHospitalWorkflows') &&
                        <Tab
                            onClick={() => setCurrentTab('preHospitalWorkflows')}
                            label={
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <HeartBrokenOutlined fontSize="small"/>
                                    <Typography>{t('forms_list.pre_hospital_workflows')}</Typography>
                                </Stack>}
                            value={'preHospitalWorkflows'}
                            sx={pillTabSx} />}
                    {availableTabs.includes('userForms') &&
                        <Tab
                            onClick={() => setCurrentTab('userForms')}
                            label={
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <ReplyOutlined fontSize="small"/>
                                    <Typography>{t('forms_list.fill_forms')}</Typography>
                                </Stack>}
                            value={'userForms'}
                            sx={pillTabSx} />}
                    {availableTabs.includes('dashboardForms') &&
                        <Tab
                            onClick={() => setCurrentTab('dashboardForms')}
                            label={
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <EditOutlined fontSize="small"/>
                                    <Typography>{t('forms_list.managed_forms')}</Typography>
                                </Stack>}
                            value={'dashboardForms'}
                            sx={pillTabSx} />}
                </Tabs>
            </Box>
            {currentTab === 'preHospitalWorkflows' && <PreHospitalWorkflowsTab />}
            {currentTab === 'dashboardForms' && <FormsManagedTab />}
            {currentTab === 'userForms' && <FormsCardList />}
        </Page>
    );
}